import { useQuery } from '@tanstack/react-query';
import { fetchPalletLoadTypeList } from '../../data-provider/select-options';

export const useGetPalletLoadType = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['shipment-pallet-load-type-list'],
    queryFn: () => fetchPalletLoadTypeList(),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled,
  });
};
